import { logStartUsage } from 'owa-analytics-start';
import { updateUserConfigurationAndService } from 'owa-userconfiguration/lib/utils/updateUserConfigurationAndService';

export default async function migrateThemeId(themeId: string): Promise<void> {
    try {
        await updateUserConfigurationAndService(
            { UserOptions: { ThemeStorageId: themeId } },
            'UserTheme'
        );
    } catch (error) {
        // this shouldn't be throwing, but since this is just a migration from a deprecated themeId,
        // there's no good reason to break bootstrap for it.
        logStartUsage('MigrateThemeIdFailed', {
            stack: error?.stack,
            error: error?.message,
            themeId,
        });
    }
}
